/**
 * Indicates a fatal error that should stop all retry attempts in SSE connections
 */
export class FatalError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FatalError';
  }
}
